<template>
  <div>
    <transition name="model">
      <form @submit.prevent="submitForm">
        <div class="modal_mask">
          <div class="modal_content">
            <div class="modal_header">
              <div class="title_modal">
                <div class="flex">
                  <h4>Editar RRIM</h4>
                  <button @click="finish_modal">
                    <i class="fas fa-window-close"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="modal-body">
              <div class="card-header">
                <ul class="nav nav-tabs card-header-tabs">
                  <li class="nav-item">
                    <a :class="active_rrim" @click="click_rrim">RRIM</a>
                  </li>
                  <li class="nav-item">
                    <a :class="active_fotos" @click="click_fotos">Fotos</a>
                  </li>
                  <li class="nav-item">
                    <a :class="active_lsp" @click="click_lsp">LSP</a>
                  </li>
                </ul>
              </div>

              <div class="tab-content">
                <div v-show="rrim">
                  <RRIM
                    @setObjOfInforGeral="getObjOfInforGeral"
                    @setListPro="getListPro"
                    @setObjMoldeFechado="getObjMoldeFechado"
                    @setObjMoldeAberto="getObjMoldeAberto"
                    @setCavity="getCavity"
                  />
                </div>
                <div v-show="fotos" class="fotos">
                  <FOTOS @SendDataImages="getObjAllImages" />
                </div>

                <div v-show="lsp">
                  <LSP :configInputs="0" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-light font-weight-bold"
                @click="click_close_modal"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-light font-weight-bold"
                @click="submit"
                data-dismiss="modal"
              >
                Salvar Edição
              </button>
              <!-- <button type="submit" class="btn btn-success font-weight-bold">
                Salvar
              </button> -->
            </div>
          </div>
        </div>
      </form>
    </transition>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { PutDataImagesLSP } from "../../../controllers/RRIM/PutDataImagesLSP";
import { PutDataImagesRRIM } from "../../../controllers/RRIM/PutDataImagesRRIM";
import { PutDataRRIM } from "../../../controllers/RRIM/PutDataRRIM";
import { sap } from "../../../http/index";
import FOTOS from "./Modules/FOTOSRRIM/LayoutView.vue";
import LSP from "./Modules/LSP/LayoutView.vue";
import RRIM from "./Modules/RRIM/LayoutView.vue";

// import { required, minLength } from '@vuelidate/validators'

export default {
  components: {
    RRIM,
    FOTOS,
    LSP,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      active_rrim: "font-weight-bold nav-link text-success",
      active_fotos: "font-weight-bold nav-link text-success",
      active_lsp: "font-weight-bold nav-link text-success",
      vmodal: true,
      rrim: true,
      fotos: false,
      lsp: false,

      dados: {
        InforGeral: Object,
        Produtos: Object,
        Molde_Fechado: Object,
        Molde_Aberto: Object,
      },
      dadosImages: Object,
      cavityTotal: null,
    };
  },
  methods: {
    getCavity(value) {
      this.cavityTotal = value;
    },
    async submit() {
      const toast = await this.$swal
        .fire({
          title: "Deseja realizar a edição?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      await this.$store.commit("SetLoadingPattern", true); // insere o loading

      const data = await this.$store.getters.$GetDataAllRRIM;

      if (data != undefined) {
        this.dados.Molde_Fechado.checklist =
          this.$store.getters.$GetDataEmitsUpdate.checklist;
        this.dados.Produtos = this.$store.getters.$GetDataEmitsUpdate.produtos;

        this.dados.Molde_Aberto.tipo_de_injecao.camera_quente =
          this.dados.Molde_Fechado.camera_quente.showCameraQuente;

        let qtdCavidades = 0;

        this.dados.Molde_Aberto.lista_ProdutoAndCavidades.map((item) => {
          qtdCavidades = Number(qtdCavidades) + Number(item.ncavidade);
        });

        const { data: moldeSapConsulta } = await sap.get(`/mold`, {
          params: {
            unidade: "MAO",
            mold_code: this.$store.state.DataAllRRIM.InforGeral.MOLDE,
          },
        });

        const numeroTotaldeCavid = moldeSapConsulta[0].cavidade;

        if (qtdCavidades > numeroTotaldeCavid) {
          const Toast = await this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: "Quantidade de Cavidades Excedida",
          });

          await this.$store.commit("SetLoadingPattern", false); // insere o loading

          return;
        }

        if (qtdCavidades <= 0) {
          const Toast = await this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: "A RRIM deve possuir um ou mais produtos no molde aberto",
          });

          await this.$store.commit("SetLoadingPattern", false); // insere o loading

          return;
        }

        const res = await PutDataRRIM(data.InforGeral.ID, this.dados);

        const DataImage = this.$store.getters.$GetDataImages;

        // Abertura de Embalagem
        const formDataImages = new FormData();
        formDataImages.append(
          "IMG_EMB_EXT",
          DataImage.AberturaEmbalagem.fotoEmbalagemE
        );
        formDataImages.append(
          "IMG_EMB_INT",
          DataImage.AberturaEmbalagem.fotoEmbalagemI
        );
        formDataImages.append(
          "IMG_EMB_EXTRA",
          DataImage.AberturaEmbalagem.fotoEmbalgemExtra.file
        );

        formDataImages.append(
          "IMG_EMB_EXTRA_DESC",
          DataImage.AberturaEmbalagem.fotoEmbalgemExtra.description
        );

        //  Molde Fechado
        formDataImages.append(
          "IMG_MF_PLA_ID",
          DataImage.MoldeFechado.FotoPlaquetadeIdentificacaodomoldeFile
        );
        formDataImages.append(
          "IMG_MF_CAM_QUENTE",
          DataImage.MoldeFechado.IDdaCâmaraQuenteFile
        );
        formDataImages.append(
          "IMG_MF_L_DIREITO",
          DataImage.MoldeFechado.FotodoLadoDireitoFile
        );
        formDataImages.append(
          "IMG_MF_L_ESQUERDO",
          DataImage.MoldeFechado.FotodoLadoEsquerdoFile
        );
        formDataImages.append(
          "IMG_MF_PLA_L_MOVEL",
          DataImage.MoldeFechado.FotodaPlacadoLadoMovelFile
        );
        formDataImages.append(
          "IMG_MF_PLA_L_FIXO",
          DataImage.MoldeFechado.FotodaPlacadoLadoFixoFile
        );
        formDataImages.append(
          "IMG_MF_L_SUPERIOR",
          DataImage.MoldeFechado.FotodoLadoSuperiorFile
        );
        formDataImages.append(
          "IMG_MF_PLA_SIS_REF",
          DataImage.MoldeFechado.FotodaPlaquetadosistemadeRefrigeraçãoFile
        );

        // Molde Aberto
        formDataImages.append(
          "IMG_MA_F_L_FIXO",
          DataImage.MoldeAberto.FotodaFacedoLadoFixoFile
        );
        formDataImages.append(
          "IMG_MA_F_L_MOVEL",
          DataImage.MoldeAberto.FotodaFacedoLadoMovelFile
        );
        formDataImages.append(
          "IMG_MA_EXTRA",
          DataImage.MoldeAberto.fotoMoldeAbertoExtra.file
        );

        formDataImages.append(
          "IMG_MA_EXTRA_DESC",
          DataImage.MoldeAberto.fotoMoldeAbertoExtra.description
        );

        await this.$store.commit("SetLoadingPattern", false); // insere o loading

        await PutDataImagesRRIM(data.InforGeral.ID, formDataImages);

        // LSP
        const DataImagesLSP = this.$store.getters.$GetImagesLSP;

        if (
          DataImagesLSP != undefined ||
          DataImagesLSP != "" ||
          DataImage.length != 0
        ) {
          let formDataLSP = new FormData();
          await DataImagesLSP.map((element) => {
            if (typeof element.file === "string") {
              formDataLSP.append("listIdOfUpdate[]", element.id);
            } else {
              formDataLSP.append("fotoEmbalagem[]", element.file);
              formDataLSP.append("descfotoEmbalagem[]", element.desc);
              formDataLSP.append(
                "quantidadefotoEmbalagem[]",
                element.quantidade
              );
              formDataLSP.append(
                "observacaofotoEmbalagem[]",
                element.observacao
              );
            }
          });

          const ImagesRRIMLSP = await PutDataImagesLSP(
            data.InforGeral.ID,
            formDataLSP
          );
        }

        if (res.status == 201) {
          const Toast = await this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Editado com Sucesso",
          });
        }

        this.$store.commit("MutationSetCancelModalEditRRIM", false);
      }
    },

    async click_close_modal() {
      const toast = await this.$swal
        .fire({
          title: "Deseja cancelar edição de RRIM?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      this.$store.commit("MutationSetCancelModalEditRRIM", false);
    },
    click_rrim() {
      this.rrim = true;
      this.fotos = false;
      this.lsp = false;
      this.active_rrim = "font-weight-bold nav-link text-success active";
      this.active_fotos = "font-weight-bold nav-link text-success ";
      this.active_lsp = "font-weight-bold nav-link text-success ";
    },

    click_fotos() {
      this.rrim = false;
      this.fotos = true;
      this.lsp = false;
      this.active_fotos = "font-weight-bold nav-link text-success active";
      this.active_rrim = "font-weight-bold nav-link text-success";
      this.active_lsp = "font-weight-bold nav-link text-success ";
    },

    click_lsp() {
      this.rrim = false;
      this.fotos = false;
      this.lsp = true;
      this.active_fotos = "font-weight-bold nav-link text-success ";
      this.active_rrim = "font-weight-bold nav-link text-success";
      this.active_lsp = "font-weight-bold nav-link text-success active";
    },

    finish_modal() {
      this.vmodal = !this.vmodal;
    },

    getObjOfInforGeral(val) {
      this.dados.InforGeral = val;
    },

    getListPro(val) {
      this.dados.Produtos = val;
    },

    getObjAllImages(val) {
      this.dadosImages = val;
    },

    getObjMoldeFechado(val) {
      this.dados.Molde_Fechado = val;
    },

    getObjMoldeAberto(val) {
      this.dados.Molde_Aberto = val;
    },
  },
};
</script>

<style scoped>
input:disabled {
  background: #6666663d;
}

.modal-open {
  overflow: hidden;
}

ul li {
  cursor: pointer;
}

.modal-body {
  width: 100%;
}

.card_end {
  justify-content: flex-end;
  display: flex;
}

.flex {
  display: flex;
  justify-content: space-between;
}

.title_modal input {
  width: 2vw;
  height: 2vw;
  border-radius: 8px;
  background: var(--red);
  color: var(--white);
  border: none;
  font-size: 0.8vw;
}

.title_modal input:hover {
  width: 2vw;
  height: 2vw;
  border-radius: 8px;
  background: var(--red);
  color: var(--white);
  border: none;
  font-size: 0.8vw;
}

.modal_mask {
  position: fixed;
  display: block;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  background: #c5c5c5d6;
  overflow: auto;
}

.modal_mask .modal_content {
  position: relative;
  width: 65%;
  /* height: 90%;   TAMANHO DE CARRAGAER NOVO RRIM*/
  margin: 13vh auto;
  background: var(--white);
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
}

.modal_mask .modal_content .modal_header {
  width: 100%;
  height: 3.5rem;
  line-height: 3.5rem;
  background: var(--green);
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
}

.modal_mask .modal_content .modal_header .title_modal {
  width: 90%;
  margin: auto;
  color: var(--white);
  font-size: 1.5rem;
  text-align: start;
  align-items: center;
  justify-content: space-between;
}

.column_1 {
  overflow-y: scroll;
}

.column_2 {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.modal_mask .modal_body {
  width: 98%;
  /* height: 90%; */
  margin: auto;
  position: relative;
  top: 0;
  left: 0;
  /* overflow-y: scroll; */
  padding: 0 15px;
  display: grid;
  gap: 1vw;
  grid-template-columns: 3.7fr 1fr;
}

.modal_mask .modal_body .cards {
  width: 100%;
  grid-column: 1/4;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 15px;
  text-align: start;
}

.modal_mask .modal_body .cards .card_informations {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--white);
  padding: 20px;
  border-radius: 10px;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.mx-3 {
  margin-left: 1rem !important;
}

.modal_mask .modal_body .cards .card_informations .title {
  width: 100%;
  color: var(--green);
}

.nav-pills .nav-link {
  border-radius: 0.35rem;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--white);
  background-color: var(--green);
}

.modal_mask .modal_body .button_modal {
  width: 100%;
  position: relative;
  grid-column: 1/4;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: flex-end;
  padding: 25px;
  justify-items: end;
  display: flex;
}

.table-content {
  overflow-y: scroll;
  /* height: 20
rem
; */
  height: 80vh;
}

.card-header {
  width: 100%;
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: var(--white);
  border-bottom: 1px solid var(--cinza);
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-tabs .nav-link.active {
  color: var(--grey);
  background-color: var(--white);
  border-color: #dddfeb #dddfeb #fff;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.35rem;
  border-top-right-radius: 0.35rem;
}

.text-success {
  color: var(--green) !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}

a {
  color: var(--green);
  text-decoration: none;
  background-color: transparent;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.modal-footer {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid var(--grayBody);
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

@media (max-width: 1240px) {
  .modal_mask .modal_body .cards {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 1100px) {
  .modal_mask .modal_body .button_modal {
    grid-template-columns: 3fr 1fr;
  }
}

@media (max-width: 907px) {
  .modal_mask .modal_body .cards {
    grid-template-columns: 1fr;
  }

  .modal_mask .modal_body .button_modal {
    grid-template-columns: 2fr 1fr;
  }
}

@media (max-width: 780px) {
  .modal_mask .modal_body .title {
    text-align: center;
  }

  .modal_mask .modal_body .button_modal {
    grid-template-columns: 1fr;
    padding: 15px 0;
    grid-gap: 10px;
    display: flex;
    flex-direction: column;
  }
}

@media (max-width: 768px) and (min-width: 426px) {
  .modal_mask .modal_content {
    width: 95%;
    font-size: 12px;
    position: relative;
    /* width: 65%; */
    margin: 30px auto;
    background: var(--white);
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 425px) {
  .modal_mask .modal_content {
    width: 95%;
    font-size: 12px;
    position: relative;
    /* width: 65%; */
    margin: 30px auto;
    background: var(--white);
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  }
}
</style>
